/**
 * "The browser is the gate" — Core Concepts (ADR-0074).
 * Reconciled from docs/concepts/browser-as-gate.mdx and product/trust/privacy.md.
 */
import type { DocPageContent } from '../types';

export const BROWSER_GATE_PAGE: DocPageContent = {
  slug: 'browser-gate',
  titleKey: 'docs.concepts.browserGate.title',
  descriptionKey: 'docs.concepts.browserGate.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.concepts.browserGate.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'structured-only',
      textKey: 'docs.concepts.browserGate.structured.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.browserGate.structured.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'identity-at-edge',
      textKey: 'docs.concepts.browserGate.identity.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.browserGate.identity.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.concepts.browserGate.offline.title',
      textKey: 'docs.concepts.browserGate.offline.body',
      links: {
        offline: {
          target: { docSlug: 'auth/identity-providers' },
          labelKey: 'docs.concepts.browserGate.offline.link',
        },
      },
    },

    {
      kind: 'heading',
      level: 2,
      id: 'why-safe',
      textKey: 'docs.concepts.browserGate.whySafe.heading',
    },
    {
      kind: 'list',
      itemKeys: [
        'docs.concepts.browserGate.whySafe.item.scope',
        'docs.concepts.browserGate.whySafe.item.gated',
        'docs.concepts.browserGate.whySafe.item.audited',
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'discovery-privacy',
      textKey: 'docs.concepts.browserGate.privacy.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.browserGate.privacy.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.concepts.browserGate.privacy.note.title',
      textKey: 'docs.concepts.browserGate.privacy.note.body',
      links: { trust: { target: { path: '/trust' }, labelKey: 'docs.common.link.trust' } },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.concepts.browserGate.next.identity.title',
          textKey: 'docs.concepts.browserGate.next.identity.text',
          to: { docSlug: 'identity' },
        },
        {
          titleKey: 'docs.concepts.browserGate.next.confirmation.title',
          textKey: 'docs.concepts.browserGate.next.confirmation.text',
          to: { docSlug: 'confirmation' },
        },
      ],
    },
  ],
};
